export default {
  items: [
    {
      name: "Statistiken",
      url: "/",
      icon: "fa fa-bar-chart",
    },
    {
      name: "Kategorien",
      url: "/categories",
      icon: "fa fa-list-alt",
    },
    {
      name: "Bestellungen",
      url: "/orders",
      icon: "fa fa-cart-plus",
    },
    {
      name: "Produkte",
      url: "/items",
      icon: "fa fa-list-alt",
    },
    {
      name: "Marinaden",
      url: "/extras",
      icon: "fa fa-circle-thin",
    },
    {
      name: "Abholorte",
      url: "/locations",
      icon: "fa fa-building",
    },
    {
      name: "Benutzer",
      url: "/users",
      icon: "fa fa-users",
    },
    {
      name: "Angebote",
      url: "/special-offers",
      icon: "fa fa-bullhorn",
    },
    {
      name: "Blogs",
      url: "/blogs",
      icon: "fa fa-newspaper-o",
    },
    {
      name: "Beliebte Produkte",
      url: "/popular",
      icon: "fa fa-diamond",
    },

    {
      name: "Benachrichtigungen",
      url: "/notifications",
      icon: "fa fa-comments",
    },
    // {
    //   name: "Galerie",
    //   url: "/gallery",
    //   icon: "fa fa-camera",
    // },
    {
      name: "Banner",
      url: "/banner",
      icon: "fa fa-address-book-o",
    },
    // {
    //   name: "Marken",
    //   url: "/brands",
    //   icon: "fa fa-id-badge",
    // },
    // {
    //   name: "Videos",
    //   url: "/videos",
    //   icon: "fa fa-video-camera",
    // },
    {
      name: "Abmelden",
      url: "/logout",
      icon: "fa fa-sign-out",
      variant: "graana-red",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/static/_nav.js